export default function coalesceClassNames(...classNames: (string | undefined | boolean)[]) {
    return classNames.filter(Boolean).join(' ').replace(/\./g, '-');
}

export function extendClassName(className: string, extension: string) {
    const names = className.split(' ');
    return names.map(n => `${n}${extension}`).join(' ');
}
